import { useCallback, useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import usePageAttachmentTabs from "../Hooks/usePageAttachmentTabs";
import ActionBarClient from "../Components/ClientDashboard/ActionBarClient";
import NavBar from "../Components/Navbars/main";
import Sidebar from "../Components/Sidebars/main";
// import TabsClient from "../Components/new-client-dashboard/Tabs";
// import TabsClientNew from "../Components/new-client-dashboard/NewTabs";
import AddInsurancePopup from "../Components/Insurance/AddInsurancePopup";
// import AddCounselModal from "../Components/new-client-dashboard/modals/add-counsel";
// import AddClientModalBody from "../Components/new-client-dashboard/modals/add-new-client";
import ContactPanels from "../Components/new-client-dashboard/tabs/contact-panel/contact-panels";
import ClientCommunication from "../Components/new-client-dashboard/tabs/client-communication";
import InsurancePanelNew from "../Components/new-client-dashboard/tabs/insurance";
import PriorCounselPanelNew from "../Components/new-client-dashboard/tabs/prior-counsel";
import Footer from "../Components/common/footer";
import RelationshipTab from "../Components/new-client-dashboard/tabs/relationship";
import {
  addClickRecord,
  fetchPageObject,
  fetchShakespeareStatus,
  getCaseId,
  getClientId,
} from "../Utils/helper";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
// import ESignatureComponent from "../Components/ClientDashboard/clientESignature";
// import DocumentRow from "../Components/DocumentRow/DocumentRow";
import PhotoTab from "../Components/new-client-dashboard/tabs/photo-tab/photo";
import PageDocsTab from "../Components/DocPage/new-tab/page-docs-tab";
// import ChatIcon from "../assets/images/client-icons/chat-icon-color.svg";
import ContactIconColor from "../assets/images/client-icons/contact-icon-color.svg";
import RelationShipIconColor from "../assets/images/client-icons/relationship-icon.svg";
import PortalColorIcon from "../assets/images/client-icons/Portal-color-icon.svg";
// import NewChangesTabs from "../Components/new-client-dashboard/NewChangesTabs";
// import MoreChangesTab from "../Components/new-client-dashboard/MoreChangesTab";
import { useClientCommunicationWebSocket } from "../contexts/ClientCommunicationWebSocketProvider";
import {
  setActiveClient,
  setCommunicationTabOpen,
  selectUnreadCountForClient,
} from "../Redux/client-communication/clientCommunicationSlice";
import ClientRelatedModal from "../Components/new-client-dashboard/modals/client-related-modal";
import addIconGold from "../assets/Add-icon-gold.svg";
import NewCounselModalClientPage from "../Components/new-client-dashboard/modals/new-counsel-modal";
import NewCaseExistingClientModalClientPage from "../Components/new-client-dashboard/modals/new-case-existing-client-modal";
import useClientRelationship from "../Components/new-client-dashboard/tabs/relationship/hooks/useClientRelationship";
import useClientPage from "../Components/new-client-dashboard/tabs/contact-panel/hooks/useClientPage";
import SmartResponsiveTabsContainerClient from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabClient";
import ClientDocumentRow from "../Components/DocumentRow/ClientDocumentRow";

// Constants
const PAGE_TITLES = {
  communication: "Client Communication",
  contact: "Contact",
  insurance: "Insurance",
  "prior-counsel": "Prior Counsel",
  relationship: "Relationship",
  portal: "Portal",
  "client-insurance": "Client Insurance",
  "prior-counsel-add": "Prior Counsel",
  "new-case-for-client": "New Case for Client",
  photo: "Photos",
};

// Subcomponents
const PageTitle = ({ currentPage }) => (
  <div
    style={{
      width: "100%",
      justifyContent: "flex-start",
      background: "var(--primary)",
      height: "25px",
      marginBottom: "5px",
    }}
  >
    <span
      className="fw-bold text-white"
      style={{
        height: "25px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {PAGE_TITLES[currentPage]}
    </span>
  </div>
);

const PageContent = ({
  currentPage,
  client_cases,
  refetch,
  refetch2,
  clientData,
  setShowPriorCounselModal,
  setShowInsuranceModal,
  pageName,
  pageIcon,
}) => {
  switch (currentPage) {
    case "all":
      return (
        <>
          <table className="table table-borderless table-earning">
            <tbody>
              {[...Array(10)].map((_, index) => (
                <tr key={`additional-${index}`} className="fake-row-2" style={{ height: "35px" }}>
                  <td colSpan="6">&nbsp;</td>
                </tr>
              ))}
            </tbody>
          </table>
        </>
      );
    case "communication":
      return <ClientCommunication />;
    case "contact":
      return <ContactPanels />;
    case "insurance":
      return (
        <InsurancePanelNew
          setShowInsuranceModal={setShowInsuranceModal}
          clientData={clientData}
          refetch={refetch2}
        />
      );
    case "prior-counsel":
      return (
        <PriorCounselPanelNew
          setShowPriorCounselModal={setShowPriorCounselModal}
          clientData={clientData}
          refetch={refetch2}
        />
      );
    case "relationship":
      return <RelationshipTab client_cases={client_cases} refetch={refetch} />;
    case "photo":
      return <PhotoTab pageId={2} pageName={"Client"} />;
    case "docs":
      return (
        <PageDocsTab
          key={`${getClientId()}-${getCaseId()}`}
          pageId={2}
          pageName={pageName}
          pageIcon={pageIcon}
        />
      );
    default:
      return null;
  }
};

const NewClientPage = () => {
  const dispatch = useDispatch();
  const clientId = getClientId();
  const caseId = getCaseId();
  const { connect, _disconnect } = useClientCommunicationWebSocket();
  const { client_cases, refetch } = useClientRelationship();
  const { clientData, refetch: refetch2 } = useClientPage(getClientId(), getCaseId());
  const [currentPage, setCurrentPage] = useState("communication");
  // const [showInsurance, setShowInsurance] = useState(false);
  // const [showCounsel, setShowCounsel] = useState(false);
  // const [showClientModal, setShowClientModal] = useState(false);
  const [clientRelPopup, setClientRelPopup] = useState(false);
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 2).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  // Get unread count for this client
  const unreadCount = useSelector((state) => selectUnreadCountForClient(state, clientId, caseId));

  const handlePageChange = useCallback(
    (pageType) => {
      setCurrentPage(pageType);
      // Update Redux when communication tab is opened/closed
      dispatch(setCommunicationTabOpen(pageType === "communication"));
    },
    [dispatch]
  );

  useEffect(() => {
    // sending page ids directly now.
    fetchShakespeareStatus(caseId, 2, dispatch);
  }, [caseId, dispatch]);

  // Set active client and connect WebSocket on mount
  useEffect(() => {
    if (clientId && caseId) {
      // Set this client as active
      dispatch(setActiveClient({ clientId, caseId }));

      // Connect WebSocket for this client (stays connected even when navigating away)
      connect(clientId, caseId);

      // Set initial tab state
      dispatch(setCommunicationTabOpen(currentPage === "communication"));
    }

    // Cleanup: only clear active client state, DON'T disconnect WebSocket
    // This allows WebSocket to persist and receive notifications even when away from this page
    return () => {
      dispatch(setActiveClient({ clientId: null, caseId: null }));
      dispatch(setCommunicationTabOpen(false));
      // Note: WebSocket remains connected to receive notifications!
    };
  }, [clientId, caseId, connect, dispatch, currentPage]);

  const [showInsuranceModal, setShowInsuranceModal] = useState(false);
  const [showPriorCounselModal, setShowPriorCounselModal] = useState(false);
  const [showAddNewCaseExisitingClient, setShowNewCaseExistingClientModal] = useState(false);

  // Memoize tab configurations
  const mainTabs = useMemo(
    () => [
      // {
      //   id: "all",
      //   label: "All",
      //   className: "tab-trapezium-cycles-corners",
      //   background: "var(--primary-60)",
      //   activeColor: "white",
      //   onClick: () => handlePageChange("all"),
      //   leftHand: false,
      // },
      {
        id: "communication",
        label: (
          <>
            Communication
            {unreadCount > 0 && currentPage !== "communication" && (
              <span
                className="badge text-bg-danger m-l-5"
                style={{
                  fontSize: "10px",
                  padding: "2px 6px",
                  borderRadius: "10px",
                  backgroundColor: "#dc3545",
                  color: "white",
                  marginLeft: "5px",
                  minHeight: "16px",
                  minWidth: "16px",
                }}
              >
                {unreadCount}
              </span>
            )}
          </>
        ),
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => {
          addClickRecord(115, 2);
          handlePageChange("communication");
        },
        leftHand: true,
        span: (
          <span
            className="ic-avatar ic-15 d-flex align-items-center "
            style={{
              width: "15px",
              height: "15px",
            }}
          >
            <i
              className="ic  ic-chat-3d"
              style={{
                width: "15px",
                height: "15px",
              }}
            />
          </span>
        ),
      },
      {
        id: "contact",
        label: "Contact",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => {
          addClickRecord(116, 2);
          handlePageChange("contact");
        },
        leftHand: true,
        span: (
          <span
            className="ic-avatar ic-15 d-flex align-items-center "
            style={{
              width: "15px",
              height: "15px",
            }}
          >
            <img src={ContactIconColor} width="25" alt="Chat" />
          </span>
        ),
      },
      {
        id: "relationship",
        label: "Relationship",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        left: "0px",
        onClick: () => {
          addClickRecord(117, 2);
          handlePageChange("relationship");
        },
        leftHand: true,
        span: (
          <span
            className="ic-avatar ic-15 d-flex align-items-center "
            style={{
              width: "15px",
              height: "15px",
            }}
          >
            <img src={RelationShipIconColor} width="25" alt="Chat" />
          </span>
        ),
      },
      {
        id: "insurance",
        label: "Insurance",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => {
          addClickRecord(118, 2);
          handlePageChange("insurance");
        },
        leftHand: true,
        span: (
          <span
            className="ic-avatar ic-15 d-flex align-items-center "
            style={{
              width: "15px",
              height: "15px",
            }}
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/insurance-icon-color_OxbamIT.svg"
              }
              width="25"
              alt="Chat"
            />
          </span>
        ),
      },
      {
        id: "prior-counsel",
        label: "Other Counsel",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        left: "0px",
        onClick: () => {
          addClickRecord(119, 2);
          handlePageChange("prior-counsel");
        },
        leftHand: true,
        span: (
          <span
            className="ic-avatar ic-15 d-flex align-items-center "
            style={{
              width: "15px",
              height: "15px",
            }}
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/litigation-icon-color_5xPGzjY.svg"
              }
              width="25"
              alt="Chat"
            />
          </span>
        ),
      },

      {
        id: "portal",
        label: "Portal",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        left: "0px",
        onClick: () => {
          addClickRecord(120, 2);
          handlePageChange("portal");
        },
        leftHand: true,
        span: (
          <span
            className="ic-avatar ic-15 d-flex align-items-center "
            style={{
              width: "15px",
              height: "15px",
            }}
          >
            <img src={PortalColorIcon} width="25" alt="Chat" />
          </span>
        ),
      },
    ],
    [handlePageChange, unreadCount, currentPage]
  );

  const relationShipAction = useMemo(
    () => [
      {
        id: "new-case-for-client",
        label: "New Case for Client",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-50)",
        activeColor: "white",
        left: "0px",
        onClick: () => {
          addClickRecord(129, 2);
          setShowNewCaseExistingClientModal(true);
        },
        leftHand: true,
        span: (
          <span className="fw-bold  ic-15 d-flex align-items-center">
            <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
          </span>
        ),
        clickId: 999,
      },
    ],
    []
  );

  const insuranceAction = useMemo(
    () => [
      {
        id: "client-insurance",
        label: "Client Insurance",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-50)",
        activeColor: "white",
        left: "0px",
        onClick: () => {
          addClickRecord(127, 2);
          setShowInsuranceModal(true);
        },
        leftHand: true,
        span: (
          <span className="fw-bold  ic-15 d-flex align-items-center">
            <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
          </span>
        ),
      },
    ],
    []
  );

  const counselAction = useMemo(
    () => [
      {
        id: "prior-counsel-add",
        label: "Other Counsel",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-50)",
        activeColor: "white",
        left: "0px",
        onClick: () => {
          addClickRecord(128, 2);
          setShowPriorCounselModal(true);
        },
        leftHand: true,
        span: (
          <span className="fw-bold  ic-15 d-flex align-items-center">
            <img className="d-flex align-items-center justify-content-center" src={addIconGold} />
          </span>
        ),
        clickId: 999,
      },
    ],
    []
  );

  const photoTabs = useMemo(
    () => [
      {
        id: "docs",
        label: "Docs",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-50)",
        activeColor: "white",
        left: "0px",
        onClick: () => {
          addClickRecord(999, 2);
          handlePageChange("docs");
        },
        leftHand: true,
        span: (
          <span className="fw-bold ic-15 d-flex align-items-center">
            <img
              src="https://simplefirm-bucket.s3.amazonaws.com/static/images/documents-icon-color_b6TvcB7.svg"
              width={15}
              height={15}
              alt=""
            />
          </span>
        ),
      },
      {
        id: "photo",
        label: "Photos",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-50)",
        activeColor: "white",
        left: "0px",
        onClick: () => {
          addClickRecord(999, 2);
          handlePageChange("photo");
        },
        leftHand: true,
        span: (
          <span
            style={{
              width: "15px",
              height: "15px",
            }}
            className="fw-bold d-flex align-items-center justify-content-center text-gold"
          >
            <img
              src={
                "https://simplefirm-bucket.s3.amazonaws.com/static/images/photo-icon-color_2CyRX1a_GgdCtlG.svg"
              }
              style={{
                width: "15px",
                height: "15px",
              }}
              alt="Detail"
            />
          </span>
        ),
      },
    ],
    []
  );
  const attachmentTabs = usePageAttachmentTabs(2, photoTabs);

  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  return (
    <>
      <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
        <Sidebar />
        <div className="page-container overflow-hidden">
          <NavBar flaggedPageName="2" />
          <ActionBarClient pageObj={pageObject} />
          <div
            className="TreatmentPage-main-container invisible-scrollbar"
            style={{
              cursor: "pointer",
            }}
          >
            <SmartResponsiveTabsContainerClient
              HandlePage={currentPage}
              tabsData={mainTabs}
              viewTab={[]}
              addTab={
                currentPage === "relationship"
                  ? relationShipAction
                  : currentPage === "insurance"
                    ? insuranceAction
                    : currentPage === "prior-counsel"
                      ? counselAction
                      : []
              }
              photoTab={attachmentTabs}
              photoTabControlled={true}
              handlePageChange={handlePageChange}
              viewType={""}
            />
            {/* <div className="d-flex align-items-center">
              <div style={{ width: "50%" }}>
                <NewChangesTabs
                  currentTab={currentPage}
                  tabsData={mainTabs}
                  height={25}
                  labelClass=" justify-content-start"
                />
              </div>
              <div style={{ width: "30%" }}>
                {currentPage === "relationship" && (
                  <MoreChangesTab
                    currentTab={currentPage}
                    tabsData={relationShipAction}
                    height={25}
                    popupTabs={true}
                    labelClass="ps-2 justify-content-center"
                  />
                )}

                {currentPage === "insurance" && (
                  <MoreChangesTab
                    currentTab={currentPage}
                    tabsData={insuranceAction}
                    height={25}
                    popupTabs={true}
                    labelClass="ps-2 justify-content-center"
                  />
                )}

                {currentPage === "prior-counsel" && (
                  <MoreChangesTab
                    currentTab={currentPage}
                    tabsData={counselAction}
                    height={25}
                    popupTabs={true}
                    labelClass="ps-2 justify-content-center"
                  />
                )}
              </div>
              <div style={{ width: "20%", position: "relative", right: "192px" }}>
                <MoreChangesTab
                  currentTab={currentPage}
                  tabsData={attachmentTabs}
                  height={25}
                  labelClass="p-l-5 p-r-5 justify-content-end"
                />
              </div>
            </div> */}

            {!["prior-counsel", "insurance", "docs", "photo"].includes(currentPage) && (
              <PageTitle currentPage={currentPage} />
            )}
            <PageContent
              currentPage={currentPage}
              clientData={clientData}
              refetch2={refetch2}
              client_cases={client_cases}
              refetch={refetch}
              setShowInsuranceModal={setShowInsuranceModal}
              setShowPriorCounselModal={setShowPriorCounselModal}
              pageName={pageObject?.name}
              pageIcon={pageObject?.page_icon}
            />

            {!["photo", "docs", "insurance", "prior-counsel"].includes(currentPage) && (
              <>
                {/* <div
                  className="e-signature-section page-container"
                  style={{ marginLeft: "0px", height: "auto" }}
                >
                  <ESignatureComponent />
                </div> */}
                <div className="d-flex documents-wrapper" style={{ marginRight: "0px" }}>
                  <div className="col-12 pe-0">
                    <ClientDocumentRow
                      pageName="Client Quick-Access"
                      clientProvider={caseId}
                      page_id={2}
                      showSaveToPage={false}
                    />
                  </div>
                </div>
              </>
            )}
            <NotesSectionDashboard pageName={"Client"} />
          </div>
        </div>
      </div>

      <Footer />

      {clientRelPopup && (
        <>
          <ClientRelatedModal
            show={clientRelPopup}
            handleClose={() => {
              addClickRecord(999, 2);
              setClientRelPopup(false);
            }}
            pageName={"Client"}
          />
        </>
      )}

      {showInsuranceModal && (
        <AddInsurancePopup
          handleClose={() => setShowInsuranceModal(false)}
          show={showInsuranceModal}
          initialTab="type"
          partyScope="client"
          initialParty={{
            type: "Client",
            id: clientId,
            name: [clientData?.client?.last_name, clientData?.client?.first_name]
              .filter(Boolean)
              .join(", "),
          }}
          onCreated={refetch2}
        />
      )}
      {showPriorCounselModal && (
        <NewCounselModalClientPage
          handleClose={() => {
            addClickRecord(999, 2);
            setShowPriorCounselModal(false);
          }}
          show={showPriorCounselModal}
          refetch={refetch2}
        />
      )}
      {showAddNewCaseExisitingClient && (
        <>
          <NewCaseExistingClientModalClientPage
            handleClose={() => {
              addClickRecord(999, 2);
              setShowNewCaseExistingClientModal(false);
            }}
            show={showAddNewCaseExisitingClient}
            refetch={refetch}
          />
        </>
      )}
      {/* {showCounsel && (
        <AddCounselModal
          handleClose={() => {
            addClickRecord(999, 2);
            setShowCounsel(false);
          }}
          show={showCounsel}
          pageName="Client"
        />
      )} */}
      {/* {showClientModal && (
        <AddClientModalBody
          handleClose={() => {
            addClickRecord(999, 2);
            setShowClientModal(false);
          }}
          show={showClientModal}
        />
      )} */}
    </>
  );
};

export default NewClientPage;
